import React from 'react';
import {
  Button,
  Stack,
} from '@mui/material';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';

import ReadinessPanel from './ReadinessPanel';
import { IReadinessActionPanelProps } from './PlanningControlCenter.types';

export default class PlanningReadinessActionPanel extends React.PureComponent<
  IReadinessActionPanelProps
> {
  render(): React.ReactNode {
    const { readiness, busy, onOpenCycle } = this.props;

    return (
      <Stack spacing={2}>
        <ReadinessPanel readiness={readiness} />

        <Button
          variant="contained"
          size="large"
          startIcon={<PlayArrowOutlinedIcon />}
          disabled={busy || readiness.ready !== 1}
          onClick={onOpenCycle}
        >
          Open Planning Cycle
        </Button>
      </Stack>
    );
  }
}
